import { create } from "zustand";
import { persist } from "zustand/middleware";

// Maid store for managing maid-specific state
export const useMaidStore = create(
  persist(
    (set, get) => ({
      // Maid user info (from service staff token)
      maidInfo: null,
      branchId: null,
      branchInfo: null,

      // Current active tab
      activeTab: "new_basket",

      // Selected order for detail view
      selectedOrder: null,

      // Actions
      setMaidInfo: (info) => set({ maidInfo: info }),
      setBranchId: (id) => set({ branchId: id }),
      setBranchInfo: (info) => set({ branchInfo: info }),
      setActiveTab: (tab) => set({ activeTab: tab }),
      setSelectedOrder: (order) => set({ selectedOrder: order }),

      // Check if maid is authenticated (has branch_id in token)
      isMaidAuthenticated: () => {
        return get().branchId !== null;
      },

      // Clear maid session
      clearMaidSession: () => set({
        maidInfo: null,
        branchId: null,
        branchInfo: null,
        activeTab: "new_basket",
        selectedOrder: null,
      }),
    }),
    {
      name: "maid-storage",
      partialize: (state) => ({
        maidInfo: state.maidInfo,
        branchId: state.branchId,
        branchInfo: state.branchInfo,
      }),
    }
  )
);

// Tab configuration for maid dashboard
// The dashboard reads these through t(), so each tab names a key rather
// than carrying one language's word.
export const MAID_TABS = [
  { id: "new_basket", labelKey: "maid.tab.new_basket" },
  { id: "preparing", labelKey: "maid.tab.preparing" },
  { id: "working", labelKey: "maid.tab.working" },
  { id: "completed", labelKey: "maid.tab.completed" },
  { id: "pickup", labelKey: "maid.tab.pickup" },
];

// Water temperature labels
export const WATER_TEMP_LABELS = {
  1: "น้ำเย็น",
  2: "น้ำอุ่น",
  3: "น้ำร้อน",
};

// Extra dryer time labels
export const DRYER_TIME_LABELS = {
  1: "5 นาที",
  2: "10 นาที",
  3: "15 นาที",
};
